import styled from "styled-components";

export const Wrapper = styled.div`
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 4fr 1.5fr;
  place-items: center;
  height: 100%;
  align-items: flex-start;
  gap: 1rem;
  padding: 1.5rem;
  max-width: 100%;
  max-height: 100%;
`;

export const LeftContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 1rem;
  padding-right: 1rem;
  border-right: 2px solid var(--grey-100);

  .associate-btn {
    position: absolute;
    bottom: 1rem;
    right: 1rem;
  }
`

export const RightContent = styled.div`
  width: 100%;
  max-height: 100%;
  height: 100%;
  overflow-y: auto;
  padding-right: 1rem;
  
  h2 {
    margin-bottom: 1.5rem;
    font-size: 20px;
    font-weight: bold;
  }

  .selected-policemen-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
`

export const AutoCompleteContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  column-gap: 1rem;
  align-items: flex-end;
`;

export const RegisterContainer = styled.div`
  width: 100%;
  padding-top: 2rem;
  padding-bottom: 1rem;
  border-top: 1px solid #525252;
`;

export const RegisterContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 3rem;

  .register-input-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;

    input {
      margin: 0;
      margin-top: 1rem;
      width: 100%;

      &:disabled {
        background: #353535cb;
        cursor: not-allowed;
      }
    }
  }
`;

export const Header = styled.header`
  display: flex;
  flex-direction: column;
  margin-bottom: 1.5rem;

  span {
    color: var(--grey-100);
    font-family: Inter, sans-serif;
  }
`;
